import { UserRole } from 'shared';

export let NavMenuItems: any[] = [
    {
        label: 'common.login',
        path: 'login',
        isAuthVisible: false,
    },
    {
        label: 'navigation.dashboard',
        path: '',
        isAuthVisible: true,
    },
    {
        label: 'navigation.my-tasks',
        visibleFor: [UserRole.Picker, UserRole.Deliverer],
        children: [
            {
                label: 'navigation.my-tasks',
                path: 'my-tasks',
                visibleFor: [UserRole.Picker, UserRole.Deliverer],
            },
            {
                label: 'navigation.deposit',
                visibleFor: [UserRole.Picker, UserRole.Deliverer],
                path: 'deposit',
                hasInitialProgressLine: true,
            },
            {
                label: 'navigation.get-delivering-task',
                path: 'task-generator',
                visibleFor: [UserRole.Deliverer],
            },
        ],
    },
    {
        label: 'navigation.my-worktimes',
        path: 'my-worktimes',
        visibleFor: [UserRole.Picker, UserRole.Deliverer],
    },
    {
        label: 'common.users',
        visibleFor: [UserRole.Administrator],
        children: [
            {
                label: 'navigation.accounts',
                path: 'accounts',
                visibleFor: [UserRole.Administrator],
            },
            {
                label: 'navigation.supplier-resources',
                path: 'supplier-resources',
                visibleFor: [UserRole.Administrator],
            },
            {
                label: 'navigation.supplier-regions',
                path: 'supplier-regions',
                visibleFor: [UserRole.Administrator, UserRole.Supporter],
            },
        ],
    },
    {
        label: 'navigation.my-account',
        visibleFor: [UserRole.User, UserRole.Picker, UserRole.Deliverer],
        children: [
            {
                label: 'navigation.my-account',
                path: 'my-account',
                visibleFor: [UserRole.User],
            },
            {
                label: 'navigation.daily-review',
                visibleFor: [UserRole.Picker, UserRole.Deliverer],
                path: 'daily-review',
                hasInitialProgressLine: true,
            },
            {
                label: 'navigation.daily-feedback',
                visibleFor: [UserRole.Picker, UserRole.Deliverer],
                path: 'daily-feedback',
                hasInitialProgressLine: true,
                onlyIfTranslated: true,
            },
            {
                label: 'navigation.knowledge-base',
                visibleFor: [UserRole.User],
                path: 'knowledge-base',
                hasInitialProgressLine: true,
                onlyIfTranslated: true,
            },
            {
                label: 'navigation.custom-page-1',
                visibleFor: [UserRole.Picker, UserRole.Deliverer],
                path: 'custom-page-1',
                hasInitialProgressLine: true,
                onlyIfTranslated: true,
            },
            {
                label: 'navigation.custom-page-2',
                visibleFor: [UserRole.Picker, UserRole.Deliverer],
                path: 'custom-page-2',
                hasInitialProgressLine: true,
                onlyIfTranslated: true,
            },
            {
                label: 'navigation.custom-page-3',
                visibleFor: [UserRole.Picker, UserRole.Deliverer],
                path: 'custom-page-3',
                hasInitialProgressLine: true,
                onlyIfTranslated: true,
            },
            {
                label: 'navigation.custom-page-4',
                visibleFor: [UserRole.Picker, UserRole.Deliverer],
                path: 'custom-page-4',
                hasInitialProgressLine: true,
                onlyIfTranslated: true,
            },
            {
                label: 'navigation.custom-page-5',
                visibleFor: [UserRole.Picker, UserRole.Deliverer],
                path: 'custom-page-5',
                hasInitialProgressLine: true,
                onlyIfTranslated: true,
            },
            {
                label: 'navigation.defective-products',
                visibleFor: [UserRole.Picker, UserRole.Deliverer],
                path: 'defective-products',
                hasInitialProgressLine: true,
                onlyIfTranslated: true,
            },
        ]
    },
    {
        label: 'navigation.orders',
        visibleFor: [UserRole.Administrator],
        children: [
            {
                label: 'navigation.orders',
                path: 'orders',
                visibleFor: [UserRole.Administrator],
                hasInitialProgressLine: true,
            },
            {
                label: 'navigation.tasks',
                path: 'tasks',
                visibleFor: [UserRole.Administrator],
                hasInitialProgressLine: true,
            },
            {
                label: 'navigation.tour-planner',
                path: 'tour-planner',
                visibleFor: [UserRole.Administrator],
                hasInitialProgressLine: true,
            },
        ],
    },
    {
        label: 'navigation.orders',
        visibleFor: [UserRole.ProviderAdmin],
        path: 'provider/orders',
        hasInitialProgressLine: true,
    },
    {
        label: 'navigation.registration',
        path: 'registration',
        isAuthVisible: false,
    },
    {
        label: 'common.logout',
        path: 'logout',
        isAuthVisible: true,
    },
];
